import styled from '@emotion/styled'

import { ShiftHours } from '@bemlo/enums'

import { Color, theme } from '../../../constants'
import { Clickable, Div, Icon, IconName } from '../../../elements'

const SHIFT_HOURS_ICON_STYLES: Record<
  ShiftHours,
  { color: Color; backgroundColor: Color; icon: IconName }
> = Object.freeze({
  [ShiftHours.DAY]: {
    color: Color.MEDIUM_BLUE,
    backgroundColor: Color.LIGHTER_BLUE,
    icon: 'DayIcon',
  },
  [ShiftHours.EVENING]: {
    color: Color.MEDIUM_RED,
    backgroundColor: Color.LIGHTER_RED,
    icon: 'EveningIcon',
  },
  [ShiftHours.NIGHT]: {
    color: Color.VIOLET,
    backgroundColor: Color.TRANSPARENT_PURPLE,
    icon: 'NightIcon',
  },
  [ShiftHours.LONG]: {
    color: Color.PINK,
    backgroundColor: Color.LIGHTER_RED,
    icon: 'DayEveningIcon',
  },
})

const IconWrapper = styled(Div)<{
  backgroundColor: Color
  selected: boolean
  disabled?: boolean
  error?: string
}>`
  border-radius: 999px;
  background-color: ${({ selected, backgroundColor }) =>
    selected ? backgroundColor : Color.GREY};
  padding: ${theme.spacing['1']}px;
  width: fit-content;
  border: ${({ error }) => `1px solid ${error ? Color.RED : 'transparent'}`};
`

export const ShiftHoursBadge = ({
  shiftHours,
  setChecked,
  checked,
  disabled,
  error,
}: {
  shiftHours: ShiftHours
  checked: boolean
  setChecked?: () => void | undefined
  disabled?: boolean
  error?: string
}) => {
  const { icon, backgroundColor, color } = SHIFT_HOURS_ICON_STYLES[shiftHours]

  return (
    <IconWrapper
      as={setChecked ? Clickable : undefined}
      onClick={setChecked}
      backgroundColor={backgroundColor}
      selected={checked}
      disabled={disabled}
      styles={{ gridArea: shiftHours }}
      error={error}
    >
      <Icon
        size="sm"
        color={checked ? color : Color.DARKEST_MEDIUM_GREY}
        name={icon}
        design="solid"
      />
    </IconWrapper>
  )
}
